import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { Context } from '../shared'
import { userType, User } from '../types/user'
import { organizationDetails } from './organization-details'
import { Organization } from '../types/organization'
import {
  organizationIdArgs,
  OrganizationIdArgs
} from '../types/organization-args'

/**
 * @deprecated Use `useCurrentUserProfile` instead
 */
export const viewer: GraphQLFieldConfig<any, Context, OrganizationIdArgs> = {
  type: new GraphQLNonNull(userType),
  description: 'Get information about the currently logged in user',
  args: organizationIdArgs,
  async resolve(_source, args, context, _info): Promise<User> {
    let currentOrganization: Organization
    const { organizationID } = args

    if (!organizationDetails.resolve) {
      throw new Error('Cannot resolve organization')
    }

    // eslint-disable-next-line prefer-const
    currentOrganization = await organizationDetails.resolve(
      _source,
      args,
      context,
      _info
    )

    const { id: defaultOrganizationID } = currentOrganization

    const {
      user: {
        user_uid,
        first_name: firstName,
        last_name: lastName,
        rasp_enabled: protect,
        preferences: { language: locale, time_format }
      }
    } = await context.connector.get(`/${defaultOrganizationID}/profile`)

    return {
      id: `${organizationID}|${user_uid}`,
      firstName,
      lastName,
      currentOrganization,
      protect,
      locale,
      datePreference: {
        showPeriod: time_format.indexOf('a') > -1
      }
    }
  }
}
